(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-customer-reviews"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function () {
      const sliderContainer = document.querySelector('.custom-customer-reviews-slider-container');
      const leftButton = document.querySelector('.custom-customer-review-slider-button-left');
      const rightButton = document.querySelector('.custom-customer-review-slider-button-right');

      const reviewsToShow= parseInt(sliderContainer.dataset.reviewsToShow,10) || 4;
      const reviewItems = sliderContainer.querySelectorAll('.grid__item');
      let currentIndex= 0;

     function updateVisibleCollections(){
       reviewItems.forEach((item,index)=>{
         if(index>=currentIndex && index<currentIndex+reviewsToShow){
           item.style.display= 'flex';
         }else{
           item.style.display= 'none';
         }
       })
     }

     function updateDisabledButton(){
       leftButton.disabled= currentIndex-reviewsToShow <0;
       rightButton.disabled= currentIndex+reviewsToShow>= reviewItems.length;
     }

      if (!sliderContainer || !leftButton || !rightButton) {
        console.error('Required elements not found!');
        return;
      }

      leftButton.addEventListener("click",()=>{
        if(currentIndex-reviewsToShow>=0){
          currentIndex-=reviewsToShow;
          updateVisibleCollections();
        }
        updateDisabledButton();
      });
      rightButton.addEventListener("click",()=>{
        if(currentIndex+reviewsToShow < reviewItems.length){
          currentIndex+=reviewsToShow;
          updateVisibleCollections();
        }
        updateDisabledButton();
      });

      updateVisibleCollections();
      updateDisabledButton();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-collection"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function () {
      const sections= document.querySelectorAll('.custom-featured-collection-layout');

      sections.forEach((section,sectionIndex)=>{
          const sliderContainer = section.querySelector('.cFeatured-collection-slider-container');
          const leftButton = section.querySelector('.cFeatured-collection-slider-button-left');
          const rightButton = section.querySelector('.cFeatured-collection-slider-button-right');
    
          const productsToShow= parseInt(sliderContainer.dataset.productsToShow,10) || 4;
          const collectionItems = sliderContainer.querySelectorAll('.grid__item');
          let currentIndex= 0;
    
         function updateVisibleCollections(){
           collectionItems.forEach((item,index)=>{
             if(index>=currentIndex && index<currentIndex+productsToShow){
               item.style.display= 'block';
             }else{
               item.style.display= 'none';
             }
           })
         }
    
         function updateDisabledButton(){
           leftButton.disabled= currentIndex-productsToShow <0;
           rightButton.disabled= currentIndex+productsToShow>= collectionItems.length;
         }
    
          if (!sliderContainer || !leftButton || !rightButton) {
            console.error('Required elements not found!');
            return;
          }
    
          leftButton.addEventListener("click",()=>{
            if(currentIndex-productsToShow>=0){
              currentIndex-=productsToShow;
              updateVisibleCollections();
            }
            updateDisabledButton();
          });
          rightButton.addEventListener("click",()=>{
            if(currentIndex+productsToShow < collectionItems.length){
              currentIndex+=productsToShow;
              updateVisibleCollections();
            }
            updateDisabledButton();
          });
    
          updateVisibleCollections();
          updateDisabledButton();
      })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-similar-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function(){
      const similarProductContainer= document.querySelectorAll('.custom-similar-products-wrapper');

      similarProductContainer.forEach((section,sectionIndex)=>{
        const productsToShow=parseInt(section.dataset.productToShowInPage,10) || 4;
        const maxProductsToShow=parseInt(section.dataset.maxProductsToShow,10) || 4;
  
        const leftButton= section.querySelector('.custom-similar-products-slider-button-left');
        const rightButton = section.querySelector('.custom-similar-products-slider-button-right');
      
            if(leftButton && rightButton){
              const products= section.querySelectorAll('.custom-similar-products');
              let currentIndex=0;
  
              const updateVisibleCollections=()=>{
                products.forEach((product,index)=>{
                  if(index>=currentIndex && index<currentIndex+productsToShow){
                    product.style.display="flex";
                  }else{
                    product.style.display="none"
                  }
                });
              }
  
              const updateDisableButtons =()=>{
                leftButton.disabled= currentIndex-productsToShow <0;
                rightButton.disabled= currentIndex+productsToShow >= products.length;
              }
          
              leftButton.addEventListener("click",()=>{
                if(currentIndex-productsToShow>=0){
                  currentIndex-=productsToShow;
                  updateVisibleCollections();
                }
                updateDisableButtons();
              });
              rightButton.addEventListener("click",()=>{
                if(currentIndex+productsToShow<maxProductsToShow){
                  currentIndex+=productsToShow;
                  updateVisibleCollections();
                }
                updateDisableButtons();
              })
              updateVisibleCollections();
              updateDisableButtons();
            }  
      })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customCollectionSlider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector('.cSlider');
    const leftButton = document.querySelector('.cCollection-slider-left-btn');
    const rightButton = document.querySelector('.cCollection-slider-right-btn');
    const slides = document.querySelectorAll('.slider-item');

    const sliderContainer = document.querySelector('.cSlider-container');
    const columnsMobile =parseInt(sliderContainer.dataset.columnsMobile, 10) ||1;
    const columnsDesktop =parseInt(sliderContainer.dataset.columnsDesktop, 10)||4;
    let itemsPerSlide = columnsDesktop;
    const slideWidth = slides[0].offsetWidth + 24; // Slide width + gap
    let currentIndex = 0;
    let maximumDots=10; //Maximum number of dots visible;

    const sliderDotsContainer = document.querySelector('.cSlider-dots');

    if (!slider || !leftButton || !rightButton) {
      console.error('Required elements not found!');
      return;
    }

    // Update itemsPerSlide based on screen size
    function updateItemsPerSlide() {
      itemsPerSlide = window.innerWidth <= 768 ? columnsMobile : columnsDesktop;
      currentIndex=0;
      updateVisibleItems();
      updateDots(currentIndex);
      updateNavigationButtons();
    }

    // Show only the visible items based on the current index
    function updateVisibleItems() {
      slides.forEach((slide, index) => {
        if (index >= currentIndex * itemsPerSlide && index < (currentIndex + 1) * itemsPerSlide) {
          slide.style.display = 'flex'; // Show visible slides
        } else {
          slide.style.display = 'none'; // Hide non-visible slides
        }
      });
    }

   // Update active dot
    function updateDots(index) {
      const totalDots = Math.ceil(slides.length / itemsPerSlide)-1;
      sliderDotsContainer.innerHTML ='';
      
      for(let i=0; i<=totalDots && i<maximumDots; i++){
         const dot = document.createElement('button');
          dot.classList.add('cDot');
          dot.setAttribute('data-index', i);
          dot.setAttribute('aria-label', `Navigate to group ${i}`);
          if (i === currentIndex) dot.classList.add('active');
    
          dot.addEventListener('click', () => {
            scrollToGroup(i);
          });
  
          sliderDotsContainer.appendChild(dot);
      }
      if(currentIndex>=maximumDots){
        const lastDot=sliderDotsContainer.querySelectorAll('.cDot')[maximumDots-1];
        lastDot.classList.add('active');
      }
    }

    // Update navigationButtons
    function updateNavigationButtons(){
      leftButton.disabled= currentIndex === 0;
      rightButton.disabled= currentIndex === Math.ceil(slides.length/itemsPerSlide)-1;
    }

    // Scroll to a specific group of slides
    function scrollToGroup(index) {
      slider.scrollLeft = index * itemsPerSlide * slideWidth;
      currentIndex = index;
      updateVisibleItems();
      updateDots(index);
      updateNavigationButtons();
    }

    // Event listeners for buttons
    rightButton.addEventListener('click', () => {
      if (currentIndex < Math.ceil(slides.length / itemsPerSlide) - 1) {
        scrollToGroup(currentIndex + 1);
      }
    });

    leftButton.addEventListener('click', () => {
      if (currentIndex > 0) {
        scrollToGroup(currentIndex - 1);
      }
    });

    // Add a resize event listener to dynamically update itemsPerSlide
    window.addEventListener('resize', updateItemsPerSlide);

    // Initialize
    updateItemsPerSlide();
    updateVisibleItems();
    updateNavigationButtons();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded',function(){
    initializeCollectionPage();
    observeCollectionChanges();
  });

  function initializeCollectionPage(){
     function updateVisibilityHeading(){
      const smallScreenHeading= document.querySelector('.large-hide h1');
      const largeScreenHeading= document.querySelector('.small-hide h1');

       if (window.innerWidth > 749) {
        if (smallScreenHeading) {
          smallScreenHeading.remove();
        }
        if (!largeScreenHeading) {
          const headingContainer= document.querySelector('.header-largeScreen');
          const heading= document.createElement('h1');
          heading.innerText=headingContainer.getAttribute('data-title');
          headingContainer.insertBefore(heading,headingContainer.firstChild);
        }
      } else {
        if (largeScreenHeading) {
          largeScreenHeading.remove();
        }
        if (!smallScreenHeading) {
          const headingContainer= document.querySelector('.header-smallScreen');
          const heading= document.createElement('h1');
          heading.innerText=headingContainer.getAttribute('data-title');
          headingContainer.insertBefore(heading,headingContainer.firstChild);
        }
      }
    }
    updateVisibilityHeading();
    window.addEventListener('resize',updateVisibilityHeading);
  }

 function observeCollectionChanges() {
  const targetNode = document.getElementById('ProductGridContainer'); // Observe the parent container
  if (!targetNode) {
    console.error('Target node (#ProductGridContainer) not found');
    return;
  }

  const config = { childList: true, subtree: true, attributes: true, characterData: true };

  const callback = function(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        initializeCollectionPage();
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
 }

  } catch(e) { console.error(e); }
})();
})();
